import { Injectable } from '@angular/core';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { TypeCPVClass } from '../../models/TypeCPVClass';
import { TypeDescMarche } from '../../models/TypeDescMarche';
import { TypeFournitures } from '../../models/TypeFournitures';
import { TypeLieu } from '../../models/TypeLieu';
import { TypeObjCPV } from '../../models/TypeObjCPV';
import { TypeTravaux } from '../../models/TypeTravaux';
import { TypeVoie } from '../../models/TypeVoie';

@Injectable({
  providedIn: 'root',
})
export class DescriptionService {
  constructor() {}

  public getDescription(controls: any, formExtractorService: FormExtractorService): TypeDescMarche {
    const objetComplementaire_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['TypeDescMarche', 'TypeObjCPV'], '_SepSep_TypeObjCPV_index_');
    let objetComplementaire_iter = 0;

    const description = new TypeDescMarche();
    description.cpv = new TypeObjCPV();

    objetComplementaire_iters.forEach(() => {
      description.cpv.objetComplementaire[objetComplementaire_iter] = new TypeCPVClass();
      description.cpv.objetComplementaire[objetComplementaire_iter].classSupplementaire = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_index_' + (objetComplementaire_iter + 1) + '_SepSep_TypeCPVClass_SepAtt_classSupplementaire');
      description.cpv.objetComplementaire[objetComplementaire_iter].classPrincipale = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_index_' + (objetComplementaire_iter + 1) + '_SepSep_TypeCPVClass_SepAtt_classPrincipale');

      objetComplementaire_iter++;
    });

    description.cpv.objetPrincipal = new TypeCPVClass();
    description.cpv.objetPrincipal.classSupplementaire = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classSupplementaire');
    description.cpv.objetPrincipal.classPrincipale = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale');

    // TODO MBO en attente retour AIFE, 
    // mise de description.natureMarche.fournitures = '' par defaut

		// switch (controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepAtt_travaux')) {
		// 	case RadioCheckBoxEnum.travauxValue:
		// 		description.natureMarche.travaux = '';
		// 		description.natureMarche.services = null;
		// 		description.natureMarche.fournitures = null;
		// 	  	break;
		// 	case RadioCheckBoxEnum.servicesValue:
		// 		description.natureMarche.travaux = null;
		// 		description.natureMarche.services = '';
		// 		description.natureMarche.fournitures = null;
		// 	  	break;
		// 	case RadioCheckBoxEnum.fournituresValue:
		// 		description.natureMarche.travaux = null;
		// 		description.natureMarche.services = null;
		// 		description.natureMarche.fournitures = '';
		// 	  	break;
		//   }
    description.natureMarche.travaux = null;
    description.natureMarche.services = null;
    description.natureMarche.fournitures = '';

    return description;
  }
}
